export const Enum = {
  get: (enums: any, value: string): any => {
    return enums[value];
  },
  contains: (enums: any, value: string): boolean => {
    for (const key in enums) {
      if (enums[key] === value) {
        return true;
      }
    }
    return false;
  },
};

export const uuid = (): string => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    (char: string) => {
      const random = (Math.random() * 16) | 0;
      const value = char === "x" ? random : (random % 4) + 8; // RFC 4122
      return value.toString(16);
    }
  );
};

export const queryToJSON = (url: string) => {
  const query: { [key: string]: string } = {};
  url = (url || location.search)
    .replace(/^.*\?/, "")
    .replace(
      /([^\=]+)\=([^\&]*)\&?/g,
      (match: string, key: string, value: string) => {
        query[key] = decodeURIComponent(value);
        return "";
      }
    );
  return query;
};

export function scaleRange(
  x: number,
  a: number,
  b: number,
  c: number,
  d: number
): number {
  return c * (1 - (x - a) / (b - a)) + (d * (x - a)) / (b - a);
}

export function classNameResolver(
  classes: string[],
  optionalClasses?: { [key: string]: boolean }
): string {
  return (
    classes.join(" ") +
    (optionalClasses
      ? " " +
        Object.keys(optionalClasses)
          .filter((s: string) => s && s !== "undefined" && optionalClasses[s])
          .join(" ")
      : "")
  );
}

export function debounce(func: () => void, wait = 50): Function {
  let h: number | any;
  return () => {
    clearTimeout(h);
    h = setTimeout(() => func(), wait);
  };
}

export const average = (array: number[]): number =>
  array.reduce((result: number, item: number): number => result + item, 0) /
  array.length;
